<template>
  <div
    id="LoginPage"
    class="animated fadeIn d-flex flex-row align-items-center vh-100"
  >
    <div class="wrap">
      <div class="login_wrap">
        <div class="login_title">
          <b-img src="static/img/logo_tp2.png" class="logo"></b-img>
          <div class="title">Smart ITS</div>
        </div>
        <div class="login_box">
          <b-form @submit.prevent="onSubmit" class="w-100">
            <b-row class="login_form_box">
              <b-col class="col-7">
                <div class="input_box">
                  <b-form-input
                    type="text"
                    v-model="userid"
                    placeholder="아이디"
                    required
                  ></b-form-input>
                  <b-form-input
                    type="password"
                    v-model="password"
                    placeholder="비밀번호"
                    required
                  ></b-form-input>
                </div>
                <!-- <b-row class="input_box">
                  <b-col class="col-12">
                  </b-col>
                </b-row>
                <b-row class="input_box">
                  <b-col class="col-12">
                  </b-col>
                </b-row> -->
              </b-col>
              <b-col class="col-5">
                <div class="btn_login">
                  <b-button type="submit">로그인</b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div class="btnGrp">
          <b-button @click="openJoinModal">회원가입 신청</b-button>
          <b-button @click="openAppDetailModal">신청내역 확인</b-button>
        </div>
      </div>
    </div>

    <b-modal
      title="로그인 실패"
      title-tag="h3"
      id="loginFailedModal"
      class="modal-danger"
      title-class="ftsz21"
      body-class="text-center ftsz20 h90 py30"
      footer-class="border-top-0 align-self-center"
      centered
      v-model="loginFailModal"
      @ok="loginFailModal = false"
      ok-variant="danger"
      ok-only
      ok-title="확인"
    >
      {{ loginFailMsg }}
    </b-modal>
    <b-modal
      id="joinModal"
      title="회원가입"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <join-modal
        
      >
      </join-modal>
    </b-modal>
    <b-modal
      id="applicationDetailModal"
      title="신청내역"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <application-detail-modal

      >
      </application-detail-modal>
    </b-modal>
  </div>
</template>

<script>
// import Vue from 'vue'
// import axios from 'axios'
import { mapActions, mapGetters, mapMutations } from "vuex";
import JoinModal from "./JoinModal.vue";
import ApplicationDetailModal from "./ApplicationDetailModal.vue";
// import VueRecaptcha from 'vue-recaptcha'
/* eslint-disable */

export default {
  name: "Login",
  components: {
    JoinModal,
    ApplicationDetailModal,
  },
  data: () => ({
    userid: "",
    password: "",
    isSaveId: false,
    loginFailModal: false,
    loginFailMsg: "아이디 혹은 비밀번호를 다시 확인해주세요.",
    isSignUpOpen: false,
    captchaSrc: "",
    answer: null,
  }),
  computed: {
    ...mapGetters([
      "getIsAuth",
      "getUserInfo",
      "getAlertOptions",
      "getConfirmOptions",
    ]),
  },
  mounted() {
    const msg = localStorage.getItem("authExpiredMessage");
    if (msg) {
      localStorage.removeItem("authExpiredMessage");
      this.setAlertTitle();
      this.$bvModal
        .msgBoxOk(msg, this.getAlertOptions)
        .then((value) => {})
        .catch((err) => {
          console.error(err);
        });
    }
  },
  methods: {
    ...mapActions(["websockConn"]),
    ...mapMutations(["setUserInfo", "setAlertTitle", "setConfirmTitle"]),
    async onSubmit() {
      var reqBody = {
        id: this.userid,
        password: this.password,
        site: "",
      };
      this.$http
        .post("/comn/login", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var userInfo = res.data.data;
            if (userInfo.approvalYn === "N" || userInfo.approvalYn === "X") {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk(
                  "접근이 허용되지 않은 아이디입니다.",
                  this.getAlertOptions
                )
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            } else {
              this.setUserInfo({
                loginYn: userInfo.loginYn,
                id: userInfo.userid,
                name: userInfo.username,
                auth: userInfo.auth,
              });
              this.websockConn();
              this.$router.push({ name: "dashboard" });
            }
          } else {
            if (res.data.errorCode === "FORBIDDEN_USER") {
              this.setAlertTitle();
              this.$bvModal.msgBoxOk("접근이 허용되지 않은 아이디입니다.", this.getAlertOptions);
              return;
            }
            
            if (res.data.errormsg.includes("존재하지 않는 아이디")) {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk(res.data.errormsg, this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            } else if (
              res.data.errormsg.includes("비밀번호가 맞지 않습니다.")
            ) {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk(res.data.errormsg, this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            } else {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getUserId() {
      this.userId = localStorage.getItem("sopId");
      if (this.userId && this.userId !== "") {
        this.isSaveId = true;
      }
    },
    openJoinModal() {
      this.$bvModal.show("joinModal");
    },
    openAppDetailModal() {
      this.$bvModal.show("applicationDetailModal");
    },
  },
};
</script>

<style lang="scss">
.login-btn {
  width: 7.5rem;
  height: 6.7rem;
}
.title-center .card-title {
  text-align: center;
}
.fa-big {
  font-size: 11rem;
  color: lightskyblue;
}
.login-type-3 input,
.login-type-3 button {
  height: 3rem;
}
.login-card {
  border-top-width: 5px !important;
  border-radius: 5px;
}
.login-input {
  height: 45px;
}
#LoginPage {
  background: #161d31 url("../../../static/img/login_bg3.jpg") no-repeat 0 0;
  background-size: 100% 100%;
  & .wrap {
    font-family: "나눔 고딕";
    position: relative;
    margin: 0 auto;
    padding: 0;
    min-height: 100%;
    width: 100%;
    color: #e2e2e2;
    & .login_wrap {
      width: 550px;
      height: 333px;
      margin: calc((100vh - 220px) / 2) auto 0;
      padding: 46px 53px 66px;
      background: #283046;
      border: 1px solid #404656;
      border-radius: 10px;
      & .login_title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 51px;
        margin-bottom: 40px;
        & img.logo {
          width: 75px;
          height: 100%;
        }
        & div.title {
          font-size: 48px;
          font-weight: 500;
          margin-left: 15px;
        }
      }
      & .login_box {
        width: 428px;
        height: 110px;
        display: flex;
        justify-content: center;
        margin: 0 auto;
        & .row {
          margin-left: 0 !important;
          margin-right: 0 !important;
          &.login_form_box {
            height: 100%;
            & > .col {
              display: flex;
              align-items: center;
              &.col-7 {
                flex: 0 0 calc(100% - 160px);
                max-width: calc(100% - 160px);
                justify-content: flex-start;
                flex-direction: column;
              }
              &.col-5 {
                flex: 0 0 160px;
                max-width: 160px;
                justify-content: flex-end;
              }
              & > .row:first-child {
                margin-bottom: 15px;
              }
            }
          }
          & .col {
            & .input_box {
              padding: 0px;
              & input {
                float: left;
                width: 250px;
                height: 47px;
                border: 1px solid #404656;
                background: #283046;
                border-radius: 10px;
                padding: 0px 15px 1px;
                font-size: 16px;
                color: #b4b7bd;
                &:first-child {
                  margin-bottom: 16px;
                }
              }
            }
            & .btn_login {
              display: flex;
              align-items: center;
              justify-content: center;
              & > button {
                width: 160px;
                height: 110px;
                padding: 5px 12px 7px;
                background: #7367f0;
                color: #fff;
                font-size: 18px;
                border: 10px;
                border-radius: 10px;
                &:hover {
                  background-color: #5344ed; // #0653a1;
                  border-color: #4839eb; // #054d95;
                }
              }
            }
          }
        }
      }
      & .btnGrp {
        width: 65%;
        display: flex;
        justify-content: space-between;
        margin: 10px auto 0;

        button {
          background-color: #7367f0;
          border-color: #7367f0;
          color: #fff;
          border-radius: 5px;
          padding: 6px 15px;
          
          &:hover {
            background-color: #5344ed;
            border-color: #4839eb;
          }
        }
      }
    }
  }
}
#LoginPage .login_box .row .col .input_box label {
  float: left;
  padding: 0px;
  margin-bottom: 3px;
}
#loginFailedModal .modal-dialog {
  max-width: 600px;
}
#loginFailedModal .modal-dialog .modal-body {
  border-bottom: 1px solid #393d42;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Login.vue